
import { Team } from "models/teams/Team";
import React, { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { ApiService } from "services/ApiService";
import OperationsHub from "components/operations/OperationsHub";

const OperationsPage: React.FC = () => {
    const { artistId, teamId } = useParams<{ artistId: string; teamId: string }>();
    const [team, setTeam] = useState<Team | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchTeam = async () => {
            if (!teamId) {
                setError("Team not found");
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);
                const response = await ApiService.getTeamAsync(teamId, artistId ?? "");
                if (!response || !response.data || !response.data.teamId) {
                    setError("No team found for this teamId");
                    setTeam(null);
                    return;
                }
                setTeam(response.data);
            } catch (e) {
                console.error("Failed to fetch team", e);
                setError("Failed to fetch team");
                setTeam(null);
            } finally {
                setLoading(false);
            }
        };

        void fetchTeam();
    }, [artistId, teamId]);

    if (!artistId || !teamId) {
        return (<h1>Team route params missing</h1>);
    }

    if (loading) {
        return (<h1>Loading...</h1>);
    }

    if (error || !team) {
        return (<h1>{error || "Team not found"}</h1>);
    }

    return <OperationsHub team={team} artistId={artistId} outlet={<Outlet />} />;
}

export default OperationsPage;